import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import {
  InnerCard,
  InnerContainer,
  InnerSection,
  Paragraph,
} from '../../components/InnerPageLayout';
import JsonData from '../../data/data.json';
import { SiteData } from '../../types/siteDataTypes';
import ProductHeader from '../../components/ProductHeader';

const NavLinks = styled.div`
  margin-top: 28px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const StyledLink = styled(Link)`
  font-size: 16px;
  font-weight: 500;
  color: #0f1c2d;
  text-decoration: none;
  padding: 10px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(15, 28, 45, 0.12);
  box-shadow: 0 12px 24px rgba(15, 28, 45, 0.12);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 16px 30px rgba(15, 28, 45, 0.18);
  }
`;

const Home: React.FC = () => {
  const [siteData, setSiteData] = useState<SiteData | null>(null);

  useEffect(() => {
    setSiteData(JsonData as SiteData);
  }, []);

  return (
    <>
      {siteData ? (
        <>
          <ProductHeader data={siteData.ChotStudyHomeHeader || siteData.ChotStudyPrivacyHeader} />
          <InnerSection>
            <InnerContainer>
              <InnerCard>
                {/* <PageTitle>Chot Study</PageTitle> */}
                <Paragraph>
                  Chot Study is an AI-powered learning app designed for students and lifelong
                  learners who want to actively learn from their own materials.
                </Paragraph>
                <Paragraph>
                  Instead of passively rereading notes or documents, Chot Study transforms content
                  into interactive learning experiences that reinforce understanding and recall.
                </Paragraph>
                <Paragraph>
                  The product is built around a simple idea: your documents become the foundation
                  for personalized learning - questions, games, and insights generated directly
                  from your own content.
                </Paragraph>
                <Paragraph>
                  Chot Study focuses on active learning over passive reading, structure without
                  rigidity, and clear progress with useful feedback. The result is a focused
                  study experience that helps you understand and retain what matters most.
                </Paragraph>

            {/* <SectionHeader>What problems it solves</SectionHeader>
            <List>
              <ListItem><BoldText>Personal Wellness Support:</BoldText> Provides users with AI assistants for mental health, wellness guidance, and emotional support</ListItem>
              <ListItem><BoldText>Life Management:</BoldText> Helps users manage daily tasks, meal planning, parenting challenges, and personal organization</ListItem>
              <ListItem><BoldText>Learning & Development:</BoldText> Offers educational support, language learning, career coaching, and skill development</ListItem>
              <ListItem><BoldText>Health Guidance:</BoldText> Provides symptom tracking, health information, and wellness recommendations (not medical advice)</ListItem>
              <ListItem><BoldText>Creative Support:</BoldText> Assists with creative projects, brainstorming, and artistic endeavors</ListItem>
              <ListItem><BoldText>Privacy Concerns:</BoldText> Ensures all personal conversations and context remain completely private through end-to-end encryption</ListItem>
              <ListItem><BoldText>Accessibility:</BoldText> Makes expert-level guidance available 24/7 at an affordable price</ListItem>
            </List>

            <SectionHeader>How it should work</SectionHeader>
            <Paragraph><BoldText>1. User Onboarding:</BoldText></Paragraph>
            <List>
              <ListItem>Users can register with email or social authentication</ListItem>
              <ListItem>New users get a limited free tier with basic functionality</ListItem>
              <ListItem>Premium features are available through subscription</ListItem>
              <ListItem>Users can set up their encrypted "About You" personal context</ListItem>
            </List>

            <Paragraph><BoldText>2. Home Screen Experience:</BoldText></Paragraph>
            <List>
              <ListItem>Displays a list of available AI assistants, each specialized for different life areas</ListItem>
              <ListItem>Users can reorder assistants based on preference</ListItem>
              <ListItem>Each assistant has a unique avatar, name, and description</ListItem>
              <ListItem>Popular assistants include: Wellness Guide, Psychology Companion, Health & Symptom Guide, Mind Companion, Productivity Assistant, Career Coach, Meal Planner, Parenting Advisor, Creative Partner, English Teacher, Legal Advisor</ListItem>
            </List>

            <Paragraph><BoldText>3. Chat Functionality:</BoldText></Paragraph>
            <List>
              <ListItem>Real-time chat interface with AI assistants</ListItem>
              <ListItem>Support for text, audio, and file attachments</ListItem>
              <ListItem>AI responses can include text, images, and external sources</ListItem>
              <ListItem>All messages are end-to-end encrypted</ListItem>
              <ListItem>Conversations are organized by assistant and can be browsed in conversation history</ListItem>
            </List>

            <Paragraph><BoldText>4. Privacy Features:</BoldText></Paragraph>
            <List>
              <ListItem>"About You" section for personal context is fully encrypted on both client and server</ListItem>
              <ListItem>Only the LLM can access the encrypted personal context to provide personalized responses</ListItem>
              <ListItem>All messages are encrypted and visible only to the user and the LLM</ListItem>
              <ListItem>No unauthorized access to any personal data</ListItem>
            </List>

            <Paragraph><BoldText>5. AI Assistant Capabilities:</BoldText></Paragraph>
            <List>
              <ListItem>Each assistant has specialized knowledge in their domain</ListItem>
              <ListItem>Assistants provide contextual responses based on encrypted personal information</ListItem>
              <ListItem>Responses can be customized with different tones and creativity levels</ListItem>
              <ListItem>Assistants can analyze documents and images to provide relevant insights</ListItem>
            </List>

            <Paragraph><BoldText>6. Premium Features:</BoldText></Paragraph>
            <List>
              <ListItem>Advanced AI models with better response quality</ListItem>
              <ListItem>Higher limits for file uploads and attachments</ListItem>
              <ListItem>Text-to-speech capabilities for audio responses</ListItem>
              <ListItem>Access to all specialized assistants</ListItem>
              <ListItem>Ability to save and reuse prompts</ListItem>
              <ListItem>Unlimited messages per day</ListItem>
            </List> */}

                <NavLinks>
                  <StyledLink to="/products/chot-study/privacy-policy">Privacy Policy</StyledLink>
                  <StyledLink to="/products/chot-study/terms">Terms of Service</StyledLink>
                  <StyledLink to="/products/chot-study/delete-account">Delete Account</StyledLink>
                </NavLinks>
              </InnerCard>
            </InnerContainer>
          </InnerSection>
          <Footer />
        </>
      ) : (
        <p>Loading...</p>
      )}
    </>
  );
};

export default Home;
